import {updateUser, getUsers, deleteUser} from "@/data/api/users";
import router from "@/router";
import {getValue, goToFireStore} from "@/globalFunctions";
import {MessageBox} from "element-ui";
import i18n from "@/lang";
import {advanceTestClock} from "@/data/api/stripe";

export const filters = [
    {
        field:"active",
        clearable: true,
        options: [
            { key: true, label: 'Active' },
            { key: false, label: 'Inactive' }
        ],
        placeholder: 'table.status'
    },{
        field: "sort",
        clearable: true,
        options: [
            { label: 'ID', key: 'id' },
            { label: 'Name', key: 'name' },
        ],
        placeholder: 'table.sort'
    }
];

export const columns = [
    {
        label: 'table.email',
        field: "Email",
    },
    {
        label: 'table.first-name',
        field: "FirstName",
    },
    {
        label: 'table.last-name',
        field: "LastName",
    },
    {
        label: 'table.updated',
        field: 'DocumentUpdatedDateTime',
        formatter: (x : any) => {
            return new Date(x).toLocaleString();
        }
    }
];

export const actions = [
    {
        label: 'table.test-clock',
        type: 'info',
        icon: "update",
        condition: (row: any) => {
          return !!row?.TestClock?.StripeId;
        },
        click: (row : any, index : number) => {
            router.push(router.currentRoute.path + "?dialog=test-clock&index="  + index + "&userId=" + row.Id + "&clockId=" + row.TestClock?.StripeId);
        }
    },
    {
        label: 'table.make-admin',
        type: 'primary',
        icon: "enhanced_encryption",
        click: (row : any) => {
            window.GlobalEvents.$emit("start-list-load");
            return updateUser(row.Id, {
                properties: {},
                roles: ["user", "admin"]
            }).then(() => {
                window.GlobalEvents.$emit("refresh-list");
            });
        }
    },
    {
        label: 'table.to-firestore',
        type: 'warning',
        icon: "local_fire_department",
        click: (row : any) => {
            goToFireStore({
                type: "user",
                userId: row.Id
            });
        }
    },
    {
        label: 'table.delete',
        type: 'danger',
        icon: "delete",
        click: (row : any) => {
            MessageBox({
                title: i18n.t('confirmations.delete-user.title').toString(),
                message: i18n.t('confirmations.delete-user.text').toString(),
                showCancelButton: true,
                confirmButtonClass: "el-button--info",
                cancelButtonClass: "el-button--danger",
                confirmButtonText: i18n.t('confirmations.default.confirmation-button').toString(),
                cancelButtonText: i18n.t('confirmations.default.cancel-button').toString(),
            }).then(async () => {
                window.GlobalEvents.$emit("start-list-load");
                return deleteUser(row.Id).then(() => {
                    window.GlobalEvents.$emit("refresh-list");
                })
            });
        }
    }
];

export const dialogs = {
    "test-clock": {
        tabs: [
            {
                key: "general",
                type: "single",
                sections: [
                    {
                        inputs: [
                            {
                                label: 'table.dialog.test-clock.date',
                                name: 'input_test_clock_date',
                                type: 'date',
                                required: true,
                                dateConfig: {
                                    defaultDate: () => {
                                        return new Date();
                                    },
                                    disabledDates: {
                                        function: (params: any) => {
                                            return params.date < new Date(); // Must be in the future
                                        }
                                    }
                                },
                                convert: (vm: any,x: any) => {
                                    return new Date(x * 1000);
                                },
                                reconvert: (vm: any,x: any) => {
                                    return x / 1000;
                                },
                                path: "test-clock.Date",
                                size: 100
                            }
                        ]
                    }
                ]
            }
        ],
        activeTab: "general"
    }
}

export const submitDialogForm = async (formValues : any) => {
    // Get date
    const date = new Date(formValues.Date).getTime() / 1000;
    const userId = router.currentRoute.query.userId as string;
    const clockId = router.currentRoute.query.clockId as string;

    // Advance clock
    return advanceTestClock(userId, clockId, date);
}
export const entryKey = "uid";

export const getData = async (listQuery : any) => {
    // Get items
    const {data} = await getUsers();
    let items = data;

    // Query

    // Sort
    if (listQuery.sort){
        const [field, order] = listQuery.sort.split("-")
        items = items.sort((a: any, b: any) => {
            if(getValue(a, field) < getValue(b, field)) { return order === 'asc' ? -1 : 1; }
            if(getValue(a, field) > getValue(b, field)) { return order === 'asc' ? 1 : -1; }
            return 0;
        });
    }

    return {
        data: {
            items: items,
            total: items.length
        }
    };
};
